import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/** Staff Messaging V1 — capability probe. The server decides; this only drives whether
 *  staff-only controls are rendered. Every staff route enforces independently, and the
 *  STAFF_MESSAGING_ENABLED flag is enforced in the backend, so a stale `true` here can
 *  never grant access. */
export function useStaffMessaging() {
  const { user } = useAuth();
  const { data } = useQuery({
    queryKey: ["staff-messaging-me", user?.user_id],
    queryFn: async () => (await api.get("/staff-messaging/me")).data,
    enabled: !!user,
    retry: false,
    staleTime: 60_000,
  });
  return {
    canStaffMessage: !!data?.staff_messaging,
    officialName: data?.official_name || "Startup Otter",
    officialAvatarUrl: data?.official_avatar_url || null,
  };
}
